import type { FilterKey } from './types';

export const TEST_ID = 'dronesToolbar';

export const DEFAULT_FILTER: FilterKey = 'all';

export const FILTER_KEYS: FilterKey[] = ['all', 'grounded'];
